<template>
  <div id="onlineschoollist">
    <v-layout>
      <v-card style="width:100%;background-color:#f5f5f5;">
          <v-toolbar dark color="primary" @click="$router.go(-1)">
            <v-btn small icon dark>
              <v-icon>arrow_back</v-icon>
            </v-btn>
            <v-toolbar-title>{{schoolData.school_name}}</v-toolbar-title>
          </v-toolbar>
      </v-card>
    </v-layout>

    <v-layout row wrap style="padding-top: 15px;">
      <v-flex xs12>
        <v-card style="margin:20px;margin-top: 10px; margin-bottom:0px; padding:10px;cursor:pointer;" @click="toFeature()">
          <v-layout>
            <v-flex xs4 style="display:flex; justify-content:center;">
              <img src="@/assets/icon/online-school/ic_videosekolah.svg" alt="image-alt"/>
            </v-flex>
            <v-flex xs8 style="margin-top: 10px;">
              <h2 style="font-size: 18px">Video Belajar</h2>
              <span style="font-weight:300;">Belajar lebih keren dengan video menarik</span>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card style="margin:20px;margin-top: 10px; margin-bottom:0px; padding:10px;cursor:pointer;"  @click="toLiveStreaming()">
          <v-layout>
            <v-flex xs4 style="display:flex; justify-content:center;">
              <img src="@/assets/icon/online-school/ic_livestreaming.svg" alt="image-alt"/>
            </v-flex>
            <v-flex xs8 style="margin-top: 10px;">
              <h2 style="font-size: 18px">Live Streaming</h2>
              <span style="font-weight:300;">Ikuti Pelajaran langsung dengan guru</span>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <!-- <v-flex xs12>
        <v-card style="margin:20px;margin-top: 10px; margin-bottom:0px; padding:10px;" >
          <v-layout>
            <v-flex xs4 style="display:flex; justify-content:center;">
              <img src="@/assets/icon/online-school/ic_groupchat.svg"/>
            </v-flex>
            <v-flex xs8 style="margin-top: 10px;">
              <h2 style="font-size: 18px">Group Chat Kelas</h2>
              <span style="font-weight:300;">Kamu bisa diskusi dengan teman kelas kamu</span>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex> -->
      <!-- <v-flex xs12>
        <v-card style="margin:20px;margin-top: 10px; margin-bottom:0px; padding:10px;" >
          <v-layout>
            <v-flex xs4 style="display:flex; justify-content:center;">
              <img src="@/assets/icon/online-school/ic_tugassekolah.svg"/>
            </v-flex>
            <v-flex xs8 style="margin-top: 10px;">
              <h2 style="font-size: 18px">Tugas Sekolah</h2>
              <span style="font-weight:300;">Kerjakan dan kumpulkan tugas sekolah kamu</span>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card style="margin:20px;margin-top: 10px; margin-bottom:0px; padding:10px;">
          <v-layout>
            <v-flex xs4 style="display:flex; justify-content:center;">
              <img src="@/assets/icon/online-school/ic_absen.svg"/>
            </v-flex>
            <v-flex xs8 style="margin-top: 10px;">
              <h2 style="font-size: 18px">Absen</h2>
              <span style="font-weight:300;">Isi dan lihat presensi siswa setiap hari</span>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex> -->
    </v-layout>
  </div>
</template>

<style>

</style>

<script>
// import { mapGetters } from 'vuex'
/* eslint-disable */
export default {
  name: 'online-school-list-feature-component',
  data () {
    return {
      joinCode: false,
      schoolData: JSON.parse(sessionStorage.onlineSchool)
    }
  },
  methods: {
    close() {
      this.joinCode = false
    },
    join(id) {
      this.joinCode = true
    },
    toFeature () {
      this.$router.push('/online-school/video')
    },
    toLiveStreaming () {
      this.$router.push('/online-school/live-streaming')
    },
  }
}
</script>
